module.exports = __webpack_public_path__ + "static/media/smales.13164440.jpg";